// @flow
import { event as gaEvent } from './../Helpers/ga';

export function event(action: string): string => void {
  let cat = 'VideoRow';

  if (typeof window !== 'undefined' && typeof window.APP !== 'undefined') {
    cat = window.APP;
  }

  return function(label): void {
    gaEvent(cat, action, label);
  }
}